import { IconProps } from "./icon.types"

export default function Twitter({
  width = 24,
  height = 23,
  color = "currentColor",
  className = "",
}: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0.256759 0L9.36588 12.1823L0.200012 22.0873H2.26348L10.289 13.4158L16.7728 22.0873H23.7935L14.1723 9.21978L22.7043 0H20.6409L13.2506 7.98633L7.27889 0H0.258127H0.256759ZM3.29035 1.52002H6.51495L20.7571 20.5673H17.5325L3.29035 1.52002Z"
        fill={color}
      />
    </svg>
  )
}
